<div *ngIf="show" #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='cancelSubscriptionModalDialogClose' type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">Cancelling a subscription</h4>
      </div>
      <div class="modal-body">
        <h3>Are you sure you want to cancel this member's subscription?</h3>
      </div>
      <div class="modal-footer">
        <button id='cancelSubscriptionModalDialogCancelNow' type="button" class="btn btn-success default-btn" (click)="submitImmediateCacellation()">Cancel Now</button>
        <button *ngIf='showEndOfPeriod'  id='cancelSubscriptionModalDialogCancelLater' type="button" class="btn btn-success default-btn" (click)="submitEndOfPeriodCacellation()">Cancel at End of Subscription Period</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/cancel-subscription-modal-dialog/cancel-subscription-modal-dialog.component.html